module.exports = __webpack_public_path__ + "static/media/zl_2_14.b6932fa6.png";